import { T_CONTACT_US_PAGE_CONSTANTS } from './TYPES'

const HU_CONTACT_US_PAGE_CONSTANTS: T_CONTACT_US_PAGE_CONSTANTS = {
  PAGE_KICKER: 'VAN TOVÁBBI KÉRDÉSE?',
  PAGE_TITLE: 'Lépjen kapcsolatba velünk',
  THANKYOU_PAGE_TITLE: 'A kérését sikeresen benyújtotta. 🎉',
  GENERIC_ERROR_TOAST_MESSAGE:
    'Valami hiba történt. Kérjük, próbálja meg később újra.'
}

export default HU_CONTACT_US_PAGE_CONSTANTS
